let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hkT9t")).then(() => parcelRequire('lvt6C'));